import { gql } from "@apollo/client";

export const GET_WEIGHTS_BY_PATIENT_ID = gql`
  query WeightsByPatientId($patient_id: ID!) {
    weightsByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;

export const GET_WEIGHT_BY_ID = gql`
  query WeightById($id: ID!) {
    weightById(_id: $id) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;

export const GET_WEIGHTS_BY_IDS = gql`
  query WeightsByIds($ids: [ID!]!) {
    weightsByIds(ids: $ids) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;
